import type { UserProfileDto } from '../../domain/contracts/api.contracts';
import { apiClient } from './apiClient';

/** E04 — GET /users/me */
export async function getMe(): Promise<UserProfileDto> {
  const { data } = await apiClient.get<UserProfileDto>('/users/me');
  return data;
}
